import { action, asyncAction } from 'now-frontend-shared/utils/actions';

// async actions
export const getCurrentProperty = asyncAction('propertyView/GET_CURRENT_PROPERTY');
export const makeBet = asyncAction('propertyView/MAKE_A_BET');

// sync actions
export const clearState = action('propertyView/CLEAR_STATE');
